import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NavigationItem } from '../navigation';
import { GradientConfig } from '../../../../../app-config';
import { Location } from '@angular/common';
import { navContentService } from './nav-content.service';
import { QubesUserManagementService } from 'src/app/pages/home/user-management-qubes/qubes-user-management.service';

type MohClinicMenus = {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
}
@Component({
  selector: 'app-nav-content',
  templateUrl: './nav-content.component.html',
  styleUrls: ['./nav-content.component.scss']
})
export class NavContentComponent implements OnInit, AfterViewInit {
  @ViewChild('myDiv') myDiv: ElementRef;
  public flyInToggle: boolean = true
  public backgroundStyle;
  // selected menu
  selectedMenuItem: string;
  public gradientConfig: any;
  public navigation: any;
  public prevDisabled: string;
  public nextDisabled: string;
  public contentWidth: number;
  public wrapperWidth: any;
  public scrollWidth: any;
  public windowWidth: number;


  public varProcessCollapse: boolean = false;
  public amdReportProcessCollapse: boolean = false;
  public pmProcessCollapse: boolean = false;
  public bmProcessCollapse: boolean = false;
  public configAMDProcessCollapse: boolean = false;
  public allVarProcessCollapse: boolean = false;
  public masterAMDProcessCollapse: boolean = false;
  public masterTSDProcessCollapse: boolean = false;
  public tsdReportCollapse: boolean = false;

  public amdModuleFlag: boolean = true;
  public tsdModuleFlag: boolean = false;
  public mmdModuleFlag: boolean = false;
  selectedNavItemIndex: number = -1;
  public panelOpenState = false;
  currentUser: any;
  userDetails: any;
  userGroups: any;
  userRoles: any;
  roles: string[];
  envAccess: any = [];
  public mohOtherUSersCoolapse6 = {
    id: 'user-management-qubess',
    title: 'SUBMIT',
    type: 'collapse',
    icon: 'feather icon-layers',
    hidden: false,
    children: [
      {
        id: 'm3',
        title: 'AOT Process',
        name: 'User',
        type: 'item',
        url: '/master/vs1clinic',
        breadcrumbs: true,
        // hidden: false,
      },
      {
        id: 'm4',
        title: 'Work Request',
        name: 'User',
        type: 'item',
        url: '/tsd/workRequestUnassigned',
        breadcrumbs: true,
        // hidden: false,
      },
    ]
  }
  public mohClinicItem1: MohClinicMenus = {
    id: 'moh-user',
    title: 'SUBMIT',
    type: 'item',
    icon: 'feather icon-layers',
    url: '/tsd/workRequestUnassigned',
    breadcrumbs: true,
    hidden: false,
  };
  public mohClinicItem2: MohClinicMenus = {
    id: 'moh-user',
    title: 'CHECK',
    type: 'item',
    icon: 'feather icon-file-minus',
    url: '/tsd/workRequestInProgress',
    breadcrumbs: true,
    hidden: false,
  };
  public mohClinicItem3: MohClinicMenus = {
    id: 'moh-user',
    title: 'Reports',
    type: 'item',
    icon: 'feather icon-briefcase',
    url: '/tsd/workOrderreportmonthwise',
    breadcrumbs: true,
    hidden: false,
  };
  public mohClinicItem4: MohClinicMenus = {
    id: 'moh-user',
    title: 'WR CallCenter',
    type: 'item',
    icon: 'feather icon-phone',
    url: '/tsd/workRequestCallCenter',
    breadcrumbs: true,
    hidden: false,
  };
  public mohOtherUSersCoolapse5 = {
    id: 'user-management-qubes',
    title: 'Reports',
    type: 'collapse',
    icon: 'feather icon-monitor',
    // hidden: false,
    children: [
      {
        id: 'm1',
        title: 'WR Report',
        name: 'User',
        type: 'item',
        url: '/tsd/workOrderreportmonthwise',
        breadcrumbs: true,
        // hidden: false,
      },
      {
        id: 'm2',
        title: 'BE Report',
        name: 'User',
        type: 'item',
        url: '/amd-report/assetReportLatest',
        breadcrumbs: true,
        // hidden: false,
      },
    ]
  }
  public mohOtherUSersCoolapse1 = {
    id: 'user-management-qubes',
    title: 'BE Asset',
    type: 'collapse',
    icon: 'feather icon-book',
    // hidden: false,
    children: [
      {
        id: 'm1',
        title: 'Asset History',
        name: 'User',
        type: 'item',
        url: '/amd-report/BE-info',
        breadcrumbs: true,
        // hidden: false,
      },
      // {
      //   id: 'm2',
      //   title: 'Asset List',
      //   type: 'item',
      //   url: '/amd-report/asseList',
      //   breadcrumbs: true,
      //   hidden: false
      // },
      {
        id: 'm3',
        title: 'Asset List',
        type: 'item',
        url: '/amd-report/assetReportLatest',
        breadcrumbs: true,
        hidden: false
      }
    ]
  };
  public mohOtherUSersCoolapse2 = {
    id: 'user-management-qubes',
    title: 'Maintenance',
    type: 'collapse',
    icon: 'feather icon-users',
    // hidden: false,
    children: [
      {
        id: 'm1',
        title: 'Work Request',
        name: 'User',
        type: 'item',
        url: '/tsd/workRequestUnassigned',
        breadcrumbs: true,
        // hidden: false,
      }, {
        id: 'm1',
        title: 'WR Complete',
        name: 'User',
        type: 'item',
        url: '/tsd/workRequestCompleted',
        breadcrumbs: true,
        // hidden: false,
      },

    ]
  };
  public mohOtherUSersCoolapse3 = {
    id: 'user-management-qubes',
    title: 'MOH Report',
    type: 'collapse',
    icon: 'feather icon-briefcase',
    // hidden: false,
    children: [
      // {
      //   id: 'm1',
      //   title: 'Asset Ageing Report',
      //   name: 'User',
      //   type: 'item',
      //   url: '/amd-report/ageingReport',
      //   breadcrumbs: true,
      //   // hidden: false,
      // },
      {
        id: 'm1',
        title: 'Provisional Penalty Report',
        name: 'User',
        type: 'item',
        url: '/tsd/provisionalschedule',
        breadcrumbs: true,
        // hidden: false,
      },
      {
        id: 'm1',
        title: 'Final Penalty Report',
        name: 'User',
        type: 'item',
        url: '/tsd/finalschedule',
        breadcrumbs: true,
        // hidden: false,
      },
      {
        id: 'm1',
        title: 'Uptime Penalty Report',
        name: 'User',
        type: 'item',
        url: '/tsd/uptimePenaltyReport',
        breadcrumbs: true,
        // hidden: false,
      },
      {
        id: 'm1',
        title: 'WR Report',
        name: 'User',
        type: 'item',
        url: '/tsd/workOrderreportmonthwise',
        breadcrumbs: true,
        // hidden: false,
      },
      {
        id: 'm1',
        title: 'Work Order Ageing Report',
        name: 'User',
        type: 'item',
        url: '/tsd/workOrderAgeingReport',
        breadcrumbs: true,
        // hidden: false,
      },
      {
        id: 'm1',
        title: 'Checklist',
        name: 'User',
        type: 'item',
        url: '/tsd/ppmChecklist',
        breadcrumbs: true,
        // hidden: false,
      },
    ]
  };
  public mohOtherUSersCoolapse4 = {
    id: 'user-management-qubes',
    title: 'Clinic',
    type: 'collapse',
    icon: 'feather icon-monitor',
    // hidden: false,
    children: [
      {
        id: 'm1',
        title: 'Clinic Details',
        name: 'User',
        type: 'item',
        url: '/master/clinicList',
        breadcrumbs: true,
        // hidden: false,
      },
    ]
  }

  @Output() onNavMobCollapse = new EventEmitter();

  @ViewChild('navbarContent', { static: false }) navbarContent: ElementRef;
  @ViewChild('navbarWrapper', { static: false }) navbarWrapper: ElementRef;
  


  constructor(public nav: NavigationItem, private zone: NgZone, private location: Location, private navContent: navContentService, private userManagementService: QubesUserManagementService) {
    this.gradientConfig = GradientConfig.config;
    this.windowWidth = window.innerWidth;

    this.navigation = this.nav.get();
    this.prevDisabled = 'disabled';
    this.nextDisabled = '';
    this.scrollWidth = 0;
    this.contentWidth = 0;
  }

  // Method to toggle nav-content based on emitted event
  @Input() showNavContent!: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showNavContent']) {
      console.log("Nav Content Visibility in NavContent Component:", this.showNavContent);
    }
  }
  statutoryWorkRequestLink: string = '';
  
  ngOnInit() {

    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    GradientConfig.config = {
    
      layout: (this.currentUser?.organisationId == 1) ? 'vertical':'new-vs-code-similar-nav-bar', // vertical, horizontal, new-vs-code-similar-nav-bar
      subLayout: '', // horizontal-2
      collapseMenu: false,
      layoutType: 'menu-light', // menu-dark, menu-light, dark
      headerBackColor: 'header-blue', // header-blue, header-red, header-purple, header-info, header-dark, header-orenge
      // header-green, header-yellow, header-orchidgreen, header-indigogreen, header-darkgreen, header-darkblue
      rtlLayout: false,
      navFixedLayout: true,
      headerFixedLayout: true,
      boxLayout: false,
    };
    this.gradientConfig = GradientConfig.config
    this.userDetails = this.currentUser.userDetails[0]
    this.statutoryWorkRequestLink = this.userDetails.userGroupName === 'Technician' 
  ? '/tsd/statutoryAcknoeledge' 
  : '/tsd/statutoryUnassignedWR';
    console.log("   this.userDetails ",   this.userDetails )
    this.userGroups = this.userDetails.userGroups[0]
    this.userRoles = this.userGroups.userRoles
    this.roles = this.userRoles.map(userRole => userRole.roleName)
    // this.gradientConfig = (this.currentUser.organisationId == 1) ? '' : '' 
    this.userManagementService.getAllUserGroupMenuMappingByGroupId(this.userGroups.id).subscribe((datas) => {
      this.envAccess = datas

    })


    this.navContent.headerBackground.subscribe(res => {
      this.backgroundStyle = res;
      // console.log("background style admin", res)
    })
    // console.log("Navigation : ",this.navigation);



    // if (this.windowWidth < 992) {
    //   this.gradientConfig['layout'] = 'vertical';
    //   setTimeout(() => {
    //     document.querySelector('.pcoded-navbar').classList.add('menupos-static');
    //     (document.querySelector('#nav-ps-gradient-able') as HTMLElement).style.maxHeight = '100%';
    //   }, 1500);
    // }
  }
  handleNavContentToggle(event: boolean) {
    this.showNavContent = !this.showNavContent;
    console.log("Nav Content Visibility:", this.showNavContent);
  }
  mainMenuFinder(menuName) {

    let isMenuAvailable = (this.navigation[0]?.children?.find(menu => menu.title == menuName)?.hidden)

    return !((isMenuAvailable == null) ? true : isMenuAvailable)


  }

  subMenuFinder(menuName, subMenuName) {


    let mainMenu = this.navigation[0]?.children?.find(menu => menu.title == menuName);

    let isSubMenuAvailable = (mainMenu?.children?.find(subMenu => subMenu.title == subMenuName)?.hidden);

    return !((isSubMenuAvailable == null) ? true : isSubMenuAvailable);

  }

  subSubMenuFinder(menuName, subMenuName, subSubMenuName) {


    let mainMenu = this.navigation[0]?.children?.find(menu => menu.title == menuName);

    let subMenu = (mainMenu?.children?.find(subMenu => subMenu.title == subMenuName));

    let isSubSubMenuAvailable = (subMenu?.children?.find(subSubMenu => subSubMenu.title == subSubMenuName)?.hidden)

    return !((isSubSubMenuAvailable == null) ? true : isSubSubMenuAvailable);


  }

  ngAfterViewInit() {
    if (this.gradientConfig['layout'] === 'horizontal') {
      this.contentWidth = this.navbarContent.nativeElement.clientWidth;
      this.wrapperWidth = this.navbarWrapper.nativeElement.clientWidth;
    }
  }

  scrollPlus() {
    this.scrollWidth = this.scrollWidth + (this.wrapperWidth - 80);
    if (this.scrollWidth > (this.contentWidth - this.wrapperWidth)) {
      this.scrollWidth = this.contentWidth - this.wrapperWidth + 80;
      this.nextDisabled = 'disabled';
    }
    this.prevDisabled = '';
    if (this.gradientConfig.rtlLayout) {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginRight = '-' + this.scrollWidth + 'px';
    } else {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginLeft = '-' + this.scrollWidth + 'px';
    }

    console.log('window width - ', this.windowWidth);
    console.log('content width - ', this.contentWidth);
    console.log('wrapper width - ', this.wrapperWidth);
    console.log('scroll width - ', this.scrollWidth);
  }

  scrollMinus() {
    this.scrollWidth = this.scrollWidth - this.wrapperWidth;
    if (this.scrollWidth < 0) {
      this.scrollWidth = 0;
      this.prevDisabled = 'disabled';
    }
    this.nextDisabled = '';
    if (this.gradientConfig.rtlLayout) {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginRight = '-' + this.scrollWidth + 'px';
    } else {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginLeft = '-' + this.scrollWidth + 'px';
    }
  }

  fireLeave() {
    const sections = document.querySelectorAll('.pcoded-hasmenu');
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove('active');
      sections[i].classList.remove('pcoded-trigger');
    }

    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        parent.classList.add('active');
      } else if (up_parent.classList.contains('pcoded-hasmenu')) {
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        last_parent.classList.add('active');
      }
    }
  }

  navMob() {
    if (this.windowWidth < 992 && document.querySelector('app-navigation.pcoded-navbar').classList.contains('mob-open')) {
      this.onNavMobCollapse.emit();
    }
  }

  fireOutClick() {
    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        if (this.gradientConfig['layout'] === 'vertical') {
          parent.classList.add('pcoded-trigger');
        }
        parent.classList.add('active');
      } else if (up_parent.classList.contains('pcoded-hasmenu')) {
        if (this.gradientConfig['layout'] === 'vertical') {
          up_parent.classList.add('pcoded-trigger');
        }
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        if (this.gradientConfig['layout'] === 'vertical') {
          last_parent.classList.add('pcoded-trigger');
        }
        last_parent.classList.add('active');
      }
    }
  }

  public radioObject: any = {
    id: '',
    checked: false
  };
  collapseRadio(event) {


    if (event?.target?.checked == true) {

      if (this.radioObject.id == event.target.id && this.radioObject.checked == event.target.checked) {
        event.target.checked = false;
        this.radioObject = {
          id: '',
          checked: false
        };
      } else {
        this.radioObject.id = event.target.id
        this.radioObject.checked = event.target.checked
      }


    }


  }
  contentShow(data) {
    if (this.envAccess.some((obj) => obj.menuName == data)) {
      // console.log("true----->")
      return true;
    }
    else {
      // console.log("true----->")
      return false;
    }

  }

// selected menu function
selectMenuItem(menuItem: string): void {
  this.selectedMenuItem = menuItem;
}
selectNavItem(index: number) {
  this.selectedNavItemIndex = index;
}
}
